module.exports = __webpack_public_path__ + "static/media/man-pic-2.8cdbc914.jpg";